'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useEffect } from 'react';

const ModalContext = createContext({
    get setOpen() {
        throw new Error('ModalContext is not initialized');
    },
    get open() {
        throw new Error('ModalContext is not initialized');
    },
});
const useModal = () => useContext(ModalContext);
const ModalProvider = ({ pathname, children, }) => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        setOpen(false);
    }, [pathname]);
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'auto';
        }
    }, [open]);
    // clean up document body styles on unmount
    useEffect(() => () => {
        document.body.style.overflow = 'auto';
    }, []);
    const context = { open, setOpen };
    return (jsx(ModalContext.Provider, { value: context, children: children }));
};

export { ModalContext, ModalProvider, useModal };
//# sourceMappingURL=provider.js.map
